import React from "react";
import ResponsiveWrapper from "../_responsive-wrapper";

const RadioButton = ({ options, onChange, value, layout = "horizontal" }) => {
    if (!options) return null;

    return (
        <ResponsiveWrapper className={`radio-buttons radio-buttons--${layout}`}>
            {options.map((option) => (
                <label className="radio-buttons__option">
                    <input
                        className="radio-buttons__option-input"
                        id={option.value}
                        type="radio"
                        checked={value === option.value}
                        onChange={() => onChange(option.value)}
                    />
                    <div className="radio-buttons__option-button">{null}</div>
                    <div className="radio-buttons__option-label">
                        {option.label}
                    </div>
                </label>
            ))}
        </ResponsiveWrapper>
    );
};

export default RadioButton;
